module.exports = __webpack_public_path__ + "static/media/campus-food-truck-catering-2.ec13d52b.jpeg";